import { LayoutComponent } from "@jelly/lesson";
import { linear as linear1, logarithmic as logarithmic1 } from "./harmonics-1";
import { linear as linear2, logarithmic as logarithmic2 } from "./harmonics-2";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        { type: "dropdown", items: [{ name: "Linear" }, { name: "Logarithmic" }], options: {} },
        { type: "dropdown", items: [{ name: "1 harmonic" }, { name: "2 harmonic" }], options: {} },
      ],
      extraContent: [[], []],
      components: [
        [linear1, linear2],
        [logarithmic1, logarithmic2],
      ],
    },
  },
};

export default component;
